import React, { useState } from "react";
import { Form, Collapse, Image, Modal } from "react-bootstrap";
import { GoogleMap, LoadScript, Autocomplete } from "@react-google-maps/api";
import { MarkerF } from "@react-google-maps/api";

import bars from "../assets/bars.svg";
import location from "../assets/location-crosshairs.svg";
import circlePossumus from "../assets/circlePossumus.png";
import close from "../assets/Close.svg";
import more from "../assets/More.svg";
import minus from "../assets/Minus.svg";
import WLT from "../assets/WLTLight.svg";

import Provinces from "../Data/provinces.json";
import places from "../Data/places.json";
import proyects from "../Data/proyects.json";
import iconMona from "../assets/iconMona.png";
import iconChipa from "../assets/iconChipa.png";
import iconRivaYork from "../assets/iconRivaYork.png";
import iconMariano from "../assets/iconMariano.png";
import iconTrapiche from "../assets/icontrapiche.png";
import IconUnicornio from "../assets/iconUnicornio.png";

import CollaboratorNoTable from "./collaboratorNoTable";
import { useCollaboratorsContext } from "../context/CollaboratorsContext";

const Gmaps = () => {
  const [pin, setPin] = useState(false);
  const [center, setCenter] = useState({ lat: -34.616135, lng: -68.329954 });
  const [autocomplete, setAutocomplete] = useState({});
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);

  const {collaborators, filterCollaboratorsByProject} = useCollaboratorsContext()


  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [person, setPerson] = useState({
    name: "",
    image: "",
    position: "",
    phone: "",
    email: "",
    proyects: "",
  });

  const [clues, setClues] = useState({
    one: true,
    two: false,
    three: false,
    four: false,
    five: false,
    six: false,
  });

  const [zoom, setZoom] = useState(12);
  const containerStyle = {
    width: "100%",
    height: "100vh",
  };

  const onLoad = React.useCallback(function callback(map) {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        setCenter({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
        setZoom(13);
        setPin(true);
      },
      function (error) {
        setCenter({ lat: -31.694499, lng: -64.242222 });
      }
    );
  }, []);

  const defaultMapOptions = {
    fullscreenControl: false,
    zoomControl: false,
    streetView: false,
    streetViewControl: false,
    mapTypeControl: false,
    addressControl: false,
    mapId: "cfcc12d6b959a477",
  };

  const onLoadAuto = React.useCallback(function callback(autocompleted) {
    setAutocomplete(autocompleted);
  }, []);

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      let place = autocomplete.getPlace();
      setCenter(place.geometry.location);
      setZoom(16);
      setPin(true);
    } else {
      console.log("Autocomplete is not loaded yet!");
    }
  };

  const openOptions = () => {
    setOpen(!open);
  };

  const setLocation = () => {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        setCenter({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });

        setZoom(13);
        setPin(true);
      },
      function (error) {
        setCenter({ lat: -31.694499, lng: -64.242222 });
      }
    );
  };

  const handleChangeSelect = ({ target }) => {
    var dataset = target.options[target.selectedIndex].dataset;

    setCenter({
      lat: parseFloat(dataset.lat, 10),
      lng: parseFloat(dataset.lng, 10),
    });
    setZoom(parseFloat(dataset.zoom));
    setPin(false);
  };

  const handleClickMore = () => {
    setZoom(zoom + 1);
  };

  const handleClicMinus = () => {
    setZoom(zoom - 1);
  };

  const handleProyectChange = ({ target }) => {
    filterCollaboratorsByProject(target.value);
  };
  return (
    <>
      <LoadScript
        id="script-loader"
        googleMapsApiKey={process.env.REACT_APP_GMAPS_API}
        region="BD"
        libraries={["places"]}
        mapIds={["cfcc12d6b959a477"]}
      >
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          onLoad={onLoad}
          zoom={zoom}
          className="mapContainer"
          options={defaultMapOptions}
        >
          {pin ? (
            <MarkerF
              id="MyLocation"
              icon="https://developers.google.com/static/maps/documentation/javascript/images/default-marker.png"
              position={center}
            />
          ) : (
            ""
          )}

          {clues.one ? (
            <MarkerF
              id="QuestOne"
              icon={iconMona}
              position={{
                lat: -31.405824788154604,
                lng: -64.17800267889223,
              }}
              onClick={() => {
                setPerson({
                  name: "Me tomaron todo el vino",
                  image:
                    "https://possumustech.blob.core.windows.net/staticfiles/Mona_e0640c4294.png",
                  position:
                    "Despues de la gira, a Uni le dio hambre, y se fue comer unos chipas (Ojo, no a nuestro Chipa) ",
                  phone: "",
                  email: "",
                  proyects: "¿Litoral quizás?",
                });
                handleShow();
                setClues({
                  one: false,
                  two: true,
                  three: false,
                  four: false,
                  five: false,
                  six: false,
                });
              }}
            />
          ) : (
            ""
          )}
          {clues.two ? (
            <MarkerF
              id="QuestOne"
              icon={iconChipa}
              position={{
                lat: -26.189588313051907,
                lng: -58.15893416684623,
              }}
              onClick={() => {
                setPerson({
                  name: "Son Horribles, me dijo",
                  image:
                    "https://possumustech.blob.core.windows.net/staticfiles/Angel_Albornoz_d4b9c9ae63.png",
                  position:
                    "Y me conto que le hablaron de un Nueva York Argentino, y queria conocerlo...",
                  phone: "",
                  email: "",
                  proyects: "Sabes donde es ;)",
                });
                handleShow();
                setClues({
                  one: false,
                  two: false,
                  three: true,
                  four: false,
                  five: false,
                  six: false,
                });
              }}
            />
          ) : (
            ""
          )}

          {clues.three ? (
            <MarkerF
              id="QuestOne"
              icon={iconRivaYork}
              position={{
                lat: -33.19657383204873,
                lng: -68.45764807947357,
              }}
              onClick={() => {
                setPerson({
                  name: "¿Y yo que hago con un Unicornio?",
                  image:
                    "https://possumustech.blob.core.windows.net/staticfiles/Palma_Meme_d85ab3b590.png",
                  position:
                    "Le pregunte a Mariano que hago con el, y me dijo To The Pool!!!",
                  phone: "",
                  email: "",
                  proyects: "Hace justo un año",
                });
                handleShow();
                setClues({
                  one: false,
                  two: false,
                  three: false,
                  four: true,
                  five: false,
                  six: false,
                });
              }}
            />
          ) : (
            ""
          )}
          {clues.four ? (
            <MarkerF
              id="QuestOne"
              icon={iconMariano}
              position={{
                lat: -34.6261288734167,
                lng: -68.45001119452657,
              }}
              onClick={() => {
                setPerson({
                  name: "¡Que cagazo!",
                  image:
                    "https://possumustech.blob.core.windows.net/staticfiles/Mariano_0210410bea.png",
                  position:
                    "Un unicornio salio de la pileta diciendo ahora esta para un Trapiche cosecha '82",
                  phone: "",
                  email: "",
                  proyects: "¿Una bodega?",
                });
                handleShow();
                setClues({
                  one: false,
                  two: false,
                  three: false,
                  four: false,
                  five: true,
                  six: false,
                });
              }}
            />
          ) : (
            ""
          )}
          {clues.five ? (
            <MarkerF
              id="QuestOne"
              icon={iconTrapiche}
              position={{
                lat: -32.97323034330271,
                lng: -68.74534933671386,
              }}
              onClick={() => {
                setPerson({
                  name: "Estamos en quiebra",
                  image:
                    "https://possumustech.blob.core.windows.net/staticfiles/Hombre_Llorando_2f18036324.png",
                  position:
                    "Nos vacio la bodega, y salio por ruta 7 al grito de Euge ahi te voy!",
                  phone: "",
                  email: "",
                  proyects: "Ojalá este bien!",
                });
                handleShow();
                setClues({
                  one: false,
                  two: false,
                  three: false,
                  four: false,
                  five: false,
                  six: true,
                });
              }}
            />
          ) : (
            ""
          )}

          {clues.six ? (
            <MarkerF
              id="QuestLast"
              icon={IconUnicornio}
              position={{
                lat: -34.63478573708891,
                lng: -58.528015310148774,
              }}
              onClick={() => {
                setPerson({
                  name: "Hasta aca llego nomas",
                  image:
                    "https://possumustech.blob.core.windows.net/staticfiles/Unicorn_Two_0bfa8eb288.png",
                  position: "Por favor, avisale a Mario donde lo viste.",
                  phone: "",
                  email: "",
                  proyects: "¡Todavia sirve!",
                });
                handleShow();
                setClues({
                  one: false,
                  two: true,
                  three: false,
                  five: false,
                  six: true,
                });
              }}
            />
          ) : (
            ""
          )}

          {places.map((placeP, i) => (
            <MarkerF
              id="Possumus"
              icon={circlePossumus}
              position={{
                lat: placeP.lat,
                lng: placeP.lng,
              }}
            />
          ))}

          {collaborators
            ? collaborators.map((colaborador) =>
                colaborador.Ubicacion != null ? (
                  <MarkerF
                    id={colaborador.id}
                    key={colaborador.id}
                    icon={colaborador.Thumbnail.url}
                    position={{
                      lat: colaborador.Ubicacion.Latitud,
                      lng: colaborador.Ubicacion.Longitud,
                    }}
                    onClick={() => {
                      setPerson({
                        name: colaborador.Nombre,
                        image: colaborador.Imagen.url,
                        position: colaborador.Puesto,
                        phone: colaborador.Telefono,
                        email: colaborador.Email,
                        proyects: colaborador.Proyectos,
                      });
                      handleShow();
                    }}
                  />
                ) : (
                  ""
                )
              )
            : "Cargando"}

          <div id="options">
            <div className="searchBox">
              <div>
                <Image
                  src={bars}
                  onClick={openOptions}
                  className="menuBars"
                ></Image>
              </div>
              <div className="searchInputContainer">
                <Autocomplete
                  onLoad={onLoadAuto}
                  onPlaceChanged={onPlaceChanged}
                >
                  <input
                    type="text"
                    placeholder="Ingrese Localidad o calle"
                    className="searchInput"
                  />
                </Autocomplete>
              </div>

              <div>
                <Image
                  src={location}
                  className="menuBars"
                  onClick={setLocation}
                ></Image>
              </div>
            </div>
            <Collapse in={open}>
              <div id="searchOptions">
                <div className="options">
                  <h3>¿Que proyecto buscás?</h3>
                  <Form.Select
                    aria-label="Default select example"
                    onChange={handleProyectChange}
                  >
                    <option value="">Todos</option>

                    {proyects.map((proyect, i) => (
                      <option value={proyect.proyect} key={i}>
                        {proyect.proyect}
                      </option>
                    ))}
                  </Form.Select>
                </div>
                <div className="options">
                  <h3>¿A quien buscás?</h3>

                  <Form.Select
                    aria-label="Default select example"
                    onChange={handleChangeSelect}
                  >
                    <option
                      data-lat={-34.900414}
                      data-lng={-64.358811}
                      data-zoom={5}
                    >
                      A todos...
                    </option>

                    {collaborators.map((colaborador) =>
                      colaborador.Ubicacion != null ? (
                        <option
                          data-lat={colaborador.Ubicacion.Latitud}
                          data-lng={colaborador.Ubicacion.Longitud}
                          data-zoom={16}
                          value={colaborador.Nombre}
                          key={colaborador.id}
                        >
                          {colaborador.Nombre}
                        </option>
                      ) : (
                        ""
                      )
                    )}
                  </Form.Select>
                </div>
                <div className="options">
                  <h3>¿Donde está?</h3>

                  <Form.Select
                    aria-label="Default select example"
                    onChange={handleChangeSelect}
                  >
                    <option
                      data-lat={-34.900414}
                      data-lng={-64.358811}
                      data-zoom={5}
                    >
                      Seleccioná la provincia
                    </option>
                    {Provinces.map((provincia, i) => (
                      <option
                        data-lat={provincia.lat}
                        data-lng={provincia.lng}
                        value={provincia.name}
                        data-zoom={12}
                        key={i}
                      >
                        {provincia.name}
                      </option>
                    ))}
                  </Form.Select>
                </div>
                <div className="options">
                  <h3>¿Te perdiste?</h3>
                  <Form.Select
                    aria-label="Default select example"
                    onChange={handleChangeSelect}
                  >
                    <option
                      data-lat={-34.900414}
                      data-lng={-64.358811}
                      data-zoom={5}
                    >
                      Nuestras oficinas
                    </option>

                    {places.map((place, i) => (
                      <option
                        data-lat={place.lat}
                        data-lng={place.lng}
                        data-zoom={18}
                        value={place.name}
                        key={i}
                      >
                        {place.name}
                      </option>
                    ))}
                  </Form.Select>
                </div>
              </div>
            </Collapse>
          </div>
          <div id="zoomControls">
            <Image
              src={more}
              className="moreButton"
              onClick={handleClickMore}
            />
            <Image
              src={minus}
              className="minusButton"
              onClick={handleClicMinus}
            />
          </div>
        </GoogleMap>
      </LoadScript>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
          <Image src={close} className="close " onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <CollaboratorNoTable person={person} />
        </Modal.Body>
        <Modal.Footer>
          <Image src={WLT} alt="We love tech" width={150} />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Gmaps;
